import { Container, Grid } from '@mui/material';
import './bidask.css'

import BaseBidAskComponent from './baseComponent';


const BidAskComponentOld2 = () => {

    return (
        <Grid>
            <Container maxWidth="xl" sx={{ flex: 1, display: 'flex', flexDirection: 'column', marginTop: 1, }}>
                <Grid container display="flex" alignItems="center" marginBottom={10}>
                    <Grid sm={6} paddingX={2}>
                        {BaseBidAskComponent(1)}
                    </Grid>
                    <Grid sm={6} paddingX={2}>
                        {BaseBidAskComponent(2)}
                    </Grid>
                </Grid>
            </Container>
        </Grid >
    );
};

export default BidAskComponentOld2;
